<script>
import DatePicker from "vue2-datepicker";
import LoadingTemplate from "@/components/widgets/loading-template.vue";
import RawData from "@/components/widgets/raw-data.vue";
export default {
    name: "PrBacResolution",
    components: {
        DatePicker,
        LoadingTemplate,
        RawData
    },
    props: {
        pr: Object,
        managePR: Boolean,
        isCancelled: Boolean
    },
    methods: {
       getPrResolutionMembers(row){
        this.$emit('getPrResolutionMembers', row)
       },
       getAttachmentBacRes(id){
        this.$emit('getAttachmentBacRes', id)
       },
       saveBACResDetail(row){
        this.$emit('saveBACResDetail', row)
       },
       printBacRes(id){
        this.$emit('printBacRes', id)
       },
       updateBACMember(row, parent){
        this.$emit('updateBACMember', {row, parent})
       },
       deleteBACMember(row, parent){
        this.$emit('deleteBACMember', {row, parent})
       }
    }
}
</script>
<template>
    <b-tabs
        pills
        vertical
        nav-class="p-0"
        nav-wrapper-class="col-sm-2"
        content-class="pt-0 px-2 text-muted"
    >
        <b-tab title-item-class="mb-2" v-for="y in pr.prResolutions" :key="`PR-${pr.id}-PRS-${y.id}`" @click="getPrResolutionMembers(y)">
            <template v-slot:title>
                <span>{{y.itemCategoryGroup.name}}</span>
            </template>
            <h5 class="text-warning">BAC Details</h5>
            <div class="mb-2 p-3 broken-border">
                <div class="row">
                    <div class="col-md-4">
                        <label for="">BAC Resolution Number</label>
                        <input type="text" class="form-control" v-model="y.resolutionNumber" :disabled="isCancelled">
                    </div>
                    <div class="col-md-4">
                        <label for="">BAC Res Date:</label>
                        <date-picker
                            v-model="y.bacResAntiDate"
                            :first-day-of-week="1"
                            lang="en"
                            placeholder="Enter BAC Res Date..."
                            :disabled="isCancelled"
                        ></date-picker>
                    </div>
                    <div class="col-md-4">
                        <div class="mt-4 d-flex">
                            <button type="button" class="btn btn-success w-100 me-1" @click="saveBACResDetail(y)" v-if="managePR && !isCancelled"><i class="bx bx-save"></i>Save</button>
                            <button type="button" class="btn btn-purple w-100 me-1" @click="printBacRes(y.id)"><i class="bx bx-printer me-1"></i>Print BAC Res</button>
                            <button type="button" class="btn btn-warning w-100" @click="getAttachmentBacRes(y.id)"><i class="bx bx-paperclip me-1"></i>Attachments</button>
                        </div>
                    </div>
                </div>
            </div>
            <h5 class="text-warning">BAC Resolution Members</h5>
            <template v-if="!y.memberLoading && y.prResolutionMembers.length == 0">
                <h4>No data found...</h4>
            </template>
            <template v-if="y.memberLoading">
                <LoadingTemplate />
            </template>
            <template v-if="!y.memberLoading && y.prResolutionMembers.length > 0">
                <div v-for="w in y.prResolutionMembers" 
                    class="ms-3 mb-1 p-3 broken-border position-relative"
                    :class="{'broken-border-success': (w.status && w.status.toUpperCase() !== 'PENDING')}"
                    :key="`PR-${pr.id}-PRS-${y.id}-member${w.id}`"
                >
                    <RawData :data="w" />
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <span class="font-weight-bold text-white">
                                {{w.applicationUser.completeName}}
                                <a href="javascript:void(0);" title="Edit BAC Member" @click="updateBACMember(w, y)" v-if="((w.status && w.status.toUpperCase() === 'PENDING') || managePR) && !isCancelled">
                                    <i class="bx bx-edit"></i>
                                </a>
                                <a href="javascript:void(0);" class="text-danger" title="Remove BAC Member" @click="deleteBACMember(w, y)" v-if="((w.status && w.status.toUpperCase() === 'PENDING') || managePR) && !isCancelled">
                                    <i class="bx bx-trash"></i>
                                </a>
                            </span>
                            <div>
                                <small
                                    >{{w.bacName}} {{w.position}}</small
                                >
                            </div>
                        </div>
                        <div
                            class="text-center font-weight-bold font-size-18"
                            :class="{
                                'text-warning': (!w.status || w.status.toUpperCase() === 'PENDING'),
                                'text-green': (w.status && w.status.toUpperCase() !== 'PENDING')
                            }"
                        >
                                {{(w.status && w.status.toUpperCase() === 'APPROVED') ? 'DIGITALLY SIGNED': 'PENDING'}}
                        </div>
                    </div>
                </div>
            </template>
        </b-tab>
    </b-tabs> 
</template>